import { INPUT } from '$gbusiness/enums';

// Folder options come from the API now -- each factory has its own tree, so the
// form can no longer be a module-level constant.
export const FILE_EDIT_FORM = (folderOptions: Array<any> = []) => [
  {
    items: [
      {
        input: INPUT.TEXT,
        label: 'SCREEN.FILES.COLS.NAME',
        value: 'name',
        gridSize: 12,
      },
      {
        input: INPUT.TEXT,
        label: 'SCREEN.FILES.COLS.DESCRIPTION',
        value: 'description',
        gridSize: 12,
      },
      {
        input: INPUT.SELECT,
        label: 'SCREEN.FILES.COLS.FOLDER',
        value: 'folderId',
        options: [{ value: 0, labelText: 'All files (top level)' }, ...folderOptions],
        gridSize: 6,
      },
      {
        input: INPUT.CHECKBOX,
        label: 'SCREEN.FILES.COLS.PROTECTED',
        value: 'isProtected',
        gridSize: 6,
      },
      {
        input: INPUT.TEXT,
        label: 'SCREEN.FILES.COLS.PASSCODE',
        value: 'passcode',
        gridSize: 12,
        isHidden: (vals) => !vals?.isProtected,
      },
    ],
  },
];

export default FILE_EDIT_FORM;
